'use client';
import loadBackgroudImages from '../../common/loadBackgroudImages';
import React, { useEffect, useState, useRef } from 'react';

function Cultura() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const videoRef = useRef(null);

  // Array de items para el carrusel (imágenes y video)
  const carouselItems = [
    { type: 'image', src: '/assets/imgs/productos/personal.png' },
    { type: 'image', src: '/assets/imgs/productos/personal2.jpg' },
    { type: 'image', src: '/assets/imgs/productos/persnal-carros.jpg' },

  ];

  useEffect(() => {
    loadBackgroudImages();
  }, []);

  // Auto-play del carrusel cada 5 segundos
  useEffect(() => {
    if (!isHovered) {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === carouselItems.length - 1 ? 0 : prevIndex + 1
        );
      }, 5000); // Cambia cada 5 segundos

      return () => clearInterval(interval);
    }
  }, [isHovered, carouselItems.length]);

  // Controlar reproducción del video
  useEffect(() => {
    if (videoRef.current) {
      if (currentImageIndex === 2) { // Índice del video (tercer ítem)
        videoRef.current.play().catch(err => console.log('Error playing video:', err));
      } else {
        videoRef.current.pause();
      }
    }
  }, [currentImageIndex]);

  const handleDotClick = (index) => {
    setCurrentImageIndex(index);
  };

  return (
    <section className="cultura section-padding" id="cultura">
      <style jsx>{`
        @media screen and (max-width: 768px) {
          #cultura p {
            text-align: justify !important;
          }
        }
        
        .carousel-image {
          transition: opacity 0.6s ease-in-out;
        }
        
        .carousel-dot {
          transition: all 0.3s ease;
        }
        
        .carousel-dot:hover {
          transform: scale(1.2);
        }
      `}</style>
      <div className="container">
        <div className="row md-marg">
          <div className="col-lg-6">
            <div
              className="img md-mb80"
              style={{ position: 'relative' }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {/* Mostrar imagen o video según el tipo */}
              {carouselItems[currentImageIndex].type === 'image' ? (
                <div
                  className="bg-img carousel-image"
                  style={{
                    minHeight: '500px',
                    backgroundImage: `url(${carouselItems[currentImageIndex].src})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                  }}
                ></div>
              ) : (
                <video
                  ref={videoRef}
                  src={carouselItems[currentImageIndex].src}
                  muted
                  loop
                  playsInline
                  style={{
                    width: '100%',
                    height: '500px',
                    objectFit: 'cover'
                  }}
                />
              )}

              {/* Indicadores del carrusel (perlas) */}
              <div style={{
                position: 'absolute',
                bottom: '20px',
                left: '50%',
                transform: 'translateX(-50%)',
                display: 'flex',
                gap: '12px',
                zIndex: 10
              }}>
                {carouselItems.map((_, index) => (
                  <button
                    key={index}
                    className="carousel-dot"
                    onClick={() => handleDotClick(index)}
                    aria-label={`Ir a imagen ${index + 1}`}
                    style={{
                      width: currentImageIndex === index ? '32px' : '12px',
                      height: '12px',
                      borderRadius: '6px',
                      border: 'none',
                      background: currentImageIndex === index
                        ? '#fff'
                        : 'rgba(255, 255, 255, 0.5)',
                      cursor: 'pointer',
                      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
                      padding: 0
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="col-lg-6 valign">
            <div className="cont">
              <h6 className="sub-title main-color mb-15">Cítricos Naturales</h6>
              <h3 className="mb-30">
                Cultura <span className="fw-200">Organizacional</span>
              </h3>
              <p className="mb-20">
                Somos una compañía cuya misión es elaborar y comercializar zumos y jugos naturales. Nuestros productos están enfocados a un mercado objetivo específico y están listos para el consumo directo y procesos complementarios.
              </p>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Cultura;

